import React, {forwardRef, useEffect, useImperativeHandle, useRef} from 'react';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './menu.module.styl';

import type {ComponentProps, ReactNode} from 'react';


const classnames = hashedClasses(styles);

type Props = {
    children: ReactNode,
    ellipsisProps?: Omit<ComponentProps<typeof EllipsisTextHint>, 'children'>,
};

/**
* Renders caption for menu item, with ellipsis and bold on hover
* */
export const MenuItemCaption = forwardRef(({children, ellipsisProps}: Props, ref) => {

    const captionRef = useRef<HTMLSpanElement>(null);

    useImperativeHandle(ref, () => captionRef.current);

    useEffect(() => {
        if (captionRef.current) {
            // for -boldHover stylus hack
            captionRef.current.setAttribute(
                'data-hover',
                captionRef.current.textContent || '',
            );
        }
    }, [children]);

    return (
        <span className={classnames.caption} ref={captionRef}>
            <EllipsisTextHint {...ellipsisProps}>{children}</EllipsisTextHint>
        </span>
    );
});

MenuItemCaption.displayName = 'MenuItemCaption';
